import { render } from "./SixthComponent.vue?vue&type=template&id=7a550199&scoped=true"
import script from "./SixthComponent.vue?vue&type=script&lang=js"
export * from "./SixthComponent.vue?vue&type=script&lang=js"

import "./SixthComponent.vue?vue&type=style&index=0&id=7a550199&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a550199"]])

export default __exports__